var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 34.15H26.75C27.55 34.15 28.25 33.85 28.85 33.25C29.45 32.65 29.75 31.95 29.75 31.15V25.4C29.75 24.6 29.45 23.9 28.85 23.3C28.25 22.7 27.55 22.4 26.75 22.4H21.25V16.85H28.3C28.7 16.85 29.0417 16.7083 29.325 16.425C29.6083 16.1417 29.75 15.7833 29.75 15.35C29.75 14.9167 29.6083 14.5583 29.325 14.275C29.0417 13.9917 28.6833 13.85 28.25 13.85H19.75C19.3167 13.85 18.9583 13.9917 18.675 14.275C18.3917 14.5583 18.25 14.9167 18.25 15.35V23.9C18.25 24.3333 18.3917 24.6917 18.675 24.975C18.9583 25.2583 19.3167 25.4 19.75 25.4H26.75V31.15H19.7C19.3 31.15 18.9583 31.2917 18.675 31.575C18.3917 31.8583 18.25 32.2167 18.25 32.65C18.25 33.0833 18.3917 33.4417 18.675 33.725C18.9583 34.0083 19.3167 34.15 19.75 34.15ZM9 42C8.2 42 7.5 41.7 6.9 41.1C6.3 40.5 6 39.8 6 39V9C6 8.23333 6.3 7.54167 6.9 6.925C7.5 6.30833 8.2 6 9 6H39C39.7667 6 40.4583 6.30833 41.075 6.925C41.6917 7.54167 42 8.23333 42 9V39C42 39.8 41.6917 40.5 41.075 41.1C40.4583 41.7 39.7667 42 39 42H9ZM9 39H39V9H9V39ZM9 9V39V9Z",
    fill: "#2B2B2B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.cad8de06cfe09a2927ecc47a5a58dbe0.svg";
export { ForwardRef as ReactComponent };